/* eslint-disable import/no-cycle */
import React, { useState, useRef, useEffect } from 'react';
import { PageSection, globalizationPath, useGlobal } from '@rcg/ui-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';
import Grow from '@material-ui/core/Grow';
import { useMutation, useQuery, useApolloClient, useLazyQuery } from '@apollo/client';
import { useWindowSize } from '@react-hook/window-size';
import Sticky from 'react-stickynode';
import {
  Box,
  Typography,
  Link,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from '@material-ui/core';
import Clear from '@material-ui/icons/Clear';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import { navigate } from '@gatsbyjs/reach-router/';
import { Button } from '@rcg/ui-react/lib/components';
import { Preferences } from '..';
import {
  CURRENT_BOOKING,
  CURRENT_BOOKING_GRP,
  IS_LOGGED_IN,
  GET_PAYMENT_HISTORY,
} from '../../graphql/queries';
import { MAKE_PAYMENT } from '../../graphql/mutations';
import Loader from '../../components/Loader';
import PageSectionAvios from '../../components/PageSection';
import {
  BOOKING_TOKEN,
  FLIGHT_WARNING,
  INVALID_SAILING,
  SESSION_STORAGE_AIR_REDIRECT_ERROR,
  SESSION_STORAGE_PRICE_BOOKING,
  AFFIRM_LOGO,
  BOOKING_TYPES,
  BOOKING_STATUS_BOOKED,
  BOOKING_STATUS_OFFERED,
  BAZIL_MARKET,
  IMAGES,
  MOCKED_COURTESY_HOLD_TIME,
  UPC_PAYMENT_OPTIONS,
  NAVIGATION_PATHS,
  ROOT_PATH,
  START_PLANNING_PATH,
  START_PLANNING_USA_MARKET_PATH,
  SESSION_STORAGE_GUEST_ACCOUNT_CREATION,
  PROFILE_BOOKING_DATA,
  APPLE_PAY_LOGO,
  URL_SOURCE_APP,
  FIND_RESERVATION_PATH,
  SESSION_STORAGE_EXTERNAL_BOOKING,
  MAIN_PROFILE_BOOKING_ID,
  COOKIE_KEYS,
  AMEND_ORIGIN,
  FLIGHTS_ROUTE,
  SESSION_STORAGE_CHANGE_FLIGHTS,
  SESSION_STORAGE_BOOKING_PROFILE,
  SESSION_STORAGE_FLIGHT_TYPE_CODE,
  FLIGHTS_MANAGE,
  SESSION_STORAGE_CURRENT_BOOKING,
  STATEROOM_TYPE_AVIOS,
  REDIRECT_API_URL,
} from '../../commons/constants';

import {
  ENABLE_3DS_PAYMENT_GATEWAY,
  ENABLE_BUNDLED_TAXES_AND_FEES,
  ENABLE_NEW_PAYMENT_LAYOUT,
} from '../../commons/ld-user';
import {
  AddFlights,
  Footer,
  Header,
  Hero,
  Itinerary,
  StateroomCard,
  PaymentOverlay,
  JiraIssueCollector,
} from '../../components';
import PaymentDetails from '../../components/PaymentDetails';
import FlightsInfoContainer from '../../components/FlightsInfoContainer';
import { useStyles } from './index.style';
import {
  getSessionStorageItem,
  setSessionStorageItem,
  removeSessionStorageItem,
  getOnlyGCPaymentAmount,
  getCreditCardType,
  showAffirm,
  importAffirmScript,
  getGuestInfoFlags,
  disableEditGuestInformation,
  getGraphQLError,
  isGuestInfoComplete,
  allPropertiesDefined,
  isObjectNotEmpty,
  getCookies,
  isAGuestWithoutFlight,
  safeEncode,
  safeDecode,
} from '../../commons/utils';
import { getScheduledPayments } from '../../commons/utilSchedule';

import setCurrentSailingVar from '../../graphql/operations/localState/setCurrentSailing';
import setCurrentPriceVar from '../../graphql/operations/localState/setPriceCurrentBooking';
import setCurrentBookingVar from '../../graphql/operations/localState/setCurrentBooking';
import {
  trackSuccesGiftCardPayment,
  trackAffirmSuccess,
  trackPaymentView,
  trackPreferencesView,
  trackPageView,
  trackInteraction,
} from '../../commons/tracking/tracking';
import { trackGuestInfoInteraction } from '../../commons/tracking/editGuestInfoTracking';
import useLdFlags from '../../hooks/useLdFlags';
import GuestAccountHeader from '../../components/GuestAccountHeader';
import RoyalUpContainer from '../../components/RoyalUpContainer';
import AviosContainer from '../../components/AviosContainer';
import Dictionary from '../../commons/dictionary';
import useDictionary from '../../hooks/useDictionary';
import theme from '../../theme/booking-theme';
import NotificationBannerComponent from '../../components/NotificationBanner';
import useCommonStyles from '../../commons/useCommonStyles';

// eslint-disable-next-line consistent-return
const Dashboard = ({ location }) => {
  const handleLocation = location;
  document.body.style.backgroundColor = '#F7F8F9';
  const {
    renderContent,
    data: { lang, localizedDayjs, isoCode, market },
  } = useGlobal();
  const getDictionaryValue = useDictionary(Dictionary);

  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const mainContainer = useRef({ height: 0 });
  const styles = useCommonStyles();
  const classes = useStyles();
  const [width] = useWindowSize(360, { wait: 100 });
  const [headerState, setHeaderState] = useState({ isPanelOpen: false });
  const [modalState, setModalState] = useState({ isModalOpen: false });
  const [paymentModal, setPaymentModal] = useState(false);
  const [guestModal, setGuestModal] = useState(false);
  const [guestNumber, setGuestNumber] = useState(0);
  const [dinnerTab, setDinnerTab] = useState({ dinnerTab: false });
  const [makePaymentInfo, setMakePaymentInfo] = useState({});
  const [paymentErrorInfo, setPaymentErrorInfo] = useState(null);
  const [paymentResponseInfo, setPaymentResponseInfo] = useState(null);
  const [enableSticky, setEnableSticky] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [shouldRenderAvios, setShouldRenderAvios] = useState(false);
  const [succesUpdate, setSuccesUpdate] = useState(false);
  const [itineraryHeight, setItineraryHeight] = useState('auto');
  const [bookingId, setBookingId] = useState('');
  const [dispatchLoader, setDispatchLoader] = useState(false);
  const [propNotification, setPropNotification] = useState({
    description: '',
    open: false,
    title: '',
    type: '',
  });
  const [ldFlagsParams, setLdFlagsParams] = useState({
    country: '',
    language: '',
  });

  const calculateDaysDifference = (currentDate, bookingDate) => {
    const difference = currentDate.getTime() - bookingDate.getTime();
    return Math.ceil(difference / (1000 * 60 * 60 * 24));
  };
  const checkAvailableAvios = (ldFlags) => {
    const bookingInfo = getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING);
    const currentDate = new Date();
    const bookingDate = new Date(bookingInfo?.bookingDate);
    const daysDifference = calculateDaysDifference(currentDate, bookingDate);
    return (
      ldFlags['enable-avios'] &&
      ldFlags['avios-booking-types'].allowedBookingTypes.includes(bookingInfo.type) &&
      bookingInfo?.status === BOOKING_STATUS_BOOKED &&
      daysDifference <= 8 &&
      STATEROOM_TYPE_AVIOS.includes(bookingInfo?.stateroom?.type.split('/')[0])
    );
  };

  const [newLayoutFlag, setNewLayoutFlag] = useState();
  const [bookingCountry, setBookingCountry] = useState();
  const [guestAccountData, setGuestAccountData] = useState();
  const [fixPosition, setFixPosition] = useState(false);
  const [royalUpgrades, setRoyalUpgrades] = useState(null);
  const [trackingParams, setTrackingParams] = useState({});
  const [isCasinoBooking, setIsCasinoBooking] = useState(false);
  const [trackPageViewSent, setTrackPageViewSent] = useState(false);
  const [paymentHistoryData, setPaymentHistoryData] = useState([]);
  const [schedulePaymentData, setSchedulePaymentData] = useState({});
  const [noBookingAssociatedNotification, setNobookingAssociatedNotification] = useState(false);
  const [affirmSuccessBanner, setAffirmSuccessBanner] = useState({
    open: false,
    message: '',
  });
  const [appleSuccessBanner, setAppleSuccessBanner] = useState({
    open: false,
    cardNumber: '',
    message: '',
  });

  const royalPayway = useRef(null);
  const editGuestRef = useRef(null);
  const client = useApolloClient();
  const loggedInData = client.readQuery({ query: IS_LOGGED_IN });
  const { ldLoadingD, ldFlags } = useLdFlags(ldFlagsParams);
  const loggedIn = loggedInData?.isLoggedIn;
  const { REACT_APP_AIR_3DS_ENV, REACT_APP_API_KEY_AFFIRM, REACT_APP_AFFIRM_SCRIPT } = process.env;
  const skipCurrentBookingQuery =
    !!handleLocation && !!handleLocation.state && !!handleLocation.state.booking;
  let invalidFlightProfile = handleLocation?.state?.invalidFlightProfile;
  let invalidSailing = handleLocation?.state?.invalidSailing;

  const urlPath = globalizationPath(market, lang, ROOT_PATH);
  const airCh = getSessionStorageItem('air-ch', true);
  const upgradeEligible = Boolean(royalUpgrades?.upgradeEligible);

  const renderPayment = () => {
    if (newLayoutFlag) {
      navigate(`${urlPath}/${NAVIGATION_PATHS[0].payment}`);
    } else {
      // previously renderPaymentModal function
      setPaymentModal(true);
      setModalState({ isModalOpen: true });
      trackPaymentView();
    }
  };

  // Triger currentBookingData query only when user comes with a valid booking token outside Amend
  // since route location data is no available
  const srcApp = getSessionStorageItem(URL_SOURCE_APP, false);

  const isGrpBooking =
    getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING)?.type === BOOKING_TYPES.GRP;
  const isTABooking =
    getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING)?.type === BOOKING_TYPES.TA;

  const isNotAllowedPaymentBooking = isGrpBooking || isTABooking;

  const currentBookingQuery = isNotAllowedPaymentBooking ? CURRENT_BOOKING_GRP : CURRENT_BOOKING;

  const enableRedirect = ldFlags ? ldFlags['is-unified-manage-redirection-enabled'] : null;

  const {
    data: currentBookingData,
    error: currentBookingError,
    loading: currentBookingLoading,
    refetch,
  } = useQuery(currentBookingQuery, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    skip: (skipCurrentBookingQuery || !loggedIn) && !srcApp,
  });
  sessionStorage.setItem('retrieve', 'false');
  useEffect(() => {
    if (enableRedirect) {
      setDispatchLoader(true);
    }
  }, []);

  useEffect(() => {
    // To handle redirecction based on ldFlags, cookie
    if (currentBookingData) {
      setCurrentBookingVar(currentBookingData?.currentBooking);
      const currentToken = currentBookingData?.currentBooking?.token;

      const handleRedirection = async () => {
        try {
          const manageVerCookie = getCookies('manage_ver');
          if (manageVerCookie !== 'legacy' && manageVerCookie !== 'ignore' && currentToken) {
            // Call the redirect endpoint when manage_ver cookie is not 'legacy' or 'ignore'
            const encoded = safeEncode(currentToken);
            if (encoded) {
              window.location.replace(`${REDIRECT_API_URL}${encoded}`);
              return;
            }
          }
          setDispatchLoader(false);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error in redirection:', error);
          setDispatchLoader(false);
        }
      };

      if (enableRedirect) {
        handleRedirection();
      }
    }
  }, [currentBookingData]);

  const [executePaymentHistory, { error: dataError, data: paymentData }] = useLazyQuery(
    GET_PAYMENT_HISTORY,
    {
      fetchPolicy: 'no-cache',
      skip: isGrpBooking || isTABooking,
    },
  );

  useEffect(() => {
    if (skipCurrentBookingQuery && !isNotAllowedPaymentBooking) {
      executePaymentHistory();
    }
  }, []);

  useEffect(() => {
    if (paymentData && !dataError)
      setPaymentHistoryData(paymentData?.currentBooking?.paymentHistory);
  }, [paymentData]);

  useEffect(() => {
    importAffirmScript(REACT_APP_API_KEY_AFFIRM, REACT_APP_AFFIRM_SCRIPT);
    return () => {
      if (window.affirm) {
        window.affirm.ui.modal.close();
      }
    };
  }, []);

  const getScheduledPayment = async (bookinIdSP) => {
    const allPayments = await getScheduledPayments(`${bookinIdSP}`);
    setSchedulePaymentData(allPayments);
  };

  useEffect(() => {
    if (currentBookingData?.currentBooking || handleLocation?.state?.booking) {
      // getting booking data from booking query or location
      const bookingData = currentBookingData?.currentBooking || handleLocation?.state?.booking;
      getScheduledPayment(bookingData?.id);
      bookingData?.token && sessionStorage.setItem(BOOKING_TOKEN, safeDecode(bookingData.token));

      if (currentBookingData?.currentBooking?.paymentHistory) {
        setPaymentHistoryData(currentBookingData?.currentBooking?.paymentHistory);
      }

      setRoyalUpgrades(bookingData?.upgradesInfo);
      setBookingId(bookingData?.id);
      setIsCasinoBooking(bookingData?.isCasinoBooking);
      setBookingCountry(bookingData?.country?.code);
      const ldFlagsCountry = bookingData?.country;
      const ldFlagsCurrency = bookingData?.price?.currencyCode;
      setLdFlagsParams({
        ...ldFlagsParams,
        ldFlagsCountry,
        language: lang,
        currency: ldFlagsCurrency,
        bookingCountry: bookingData?.country?.code,
      });
    }
  }, [currentBookingData]);

  useEffect(() => {
    if (ldFlags) {
      setNewLayoutFlag(ldFlags[ENABLE_NEW_PAYMENT_LAYOUT]);
      setShouldRenderAvios(checkAvailableAvios(ldFlags));
    }
  }, [ldFlags]);

  useEffect(() => {
    setGuestAccountData(getSessionStorageItem(PROFILE_BOOKING_DATA));
  }, []);

  useEffect(() => {
    if ((currentBookingData || handleLocation?.state?.booking) && ldFlags) {
      const bookingData = currentBookingData?.currentBooking || handleLocation?.state?.booking;
      const { price, flightProfile } = bookingData || {};
      let isAFlightbooked;
      let cancelFlight;
      let changeFlight;

      flightProfile?.guests?.forEach(({ flightGuest }) => {
        if (flightGuest?.guestFlights) {
          isAFlightbooked = true;
        }
        if (flightGuest?.allowCancellation) {
          cancelFlight = true;
        }
        if (flightGuest?.allowReshop) {
          changeFlight = true;
        }
      });

      const isBookAdditionalFlight = isAGuestWithoutFlight(flightProfile);

      const reservationChannel =
        bookingData?.type &&
        `${bookingData.type?.toUpperCase()}-${bookingData.country?.code?.toLowerCase()}`;

      const manageSegmentCookie = getCookies('manage_segment');
      const getSplitExManageRes = () => {
        if (manageSegmentCookie === 'control') return 'Control';
        if (manageSegmentCookie) return 'Experiment';
        return '';
      };

      setTrackingParams({
        isUpgradeElegible: Boolean(bookingData?.upgradesInfo?.upgradeEligible),
        currency: price?.currencyCode || 'USD',
        language: lang || 'en',
        isAffirm: showAffirm(price?.currencyCode, price?.balanceDue, ldFlags),
        isFlightReserved: Boolean(isAFlightbooked),
        showFlightComponent: Boolean(!isAFlightbooked),
        isGALoggedIn: Boolean(guestAccountData),
        cancelFlight: Boolean(changeFlight),
        changeFlight: Boolean(cancelFlight && changeFlight),
        bookingInfo: bookingData,
        isBookAdditionalFlight,
        splitExManageRes: getSplitExManageRes(),
        reservationChannel,
      });
    }
  }, [currentBookingData, handleLocation, ldFlags]);

  if (currentBookingError) {
    const errorObj = getGraphQLError(currentBookingError);
    invalidFlightProfile = FLIGHT_WARNING === errorObj.type;
    invalidSailing = INVALID_SAILING === errorObj.type;
  }

  const [makePayment, { error: paymentError, data: paymentResponse }] = useMutation(MAKE_PAYMENT, {
    onError: () => {},
  });

  useEffect(() => {
    if (invalidSailing) {
      setPropNotification({
        title: renderContent(
          'amendDashboardInvalidSailingWarning',
          'Itinerary and payment information is not available for this type of sailing.',
        ),
        type: 'warning',
        open: true,
      });
    }
  }, [invalidSailing]);

  useEffect(() => {
    if (makePaymentInfo.variables) {
      makePayment(makePaymentInfo);
    }
  }, [makePaymentInfo]);

  useEffect(() => {
    setBookingCountry(handleLocation?.state?.booking?.country?.code);
  }, []);

  useEffect(() => {
    if (paymentError) {
      setPaymentErrorInfo(paymentError);
    }
    if (paymentResponse) {
      handleLocation.state = null;
      setPaymentResponseInfo(paymentResponse);
    }
    // eslint-disable-next-line
  }, [paymentError, paymentResponse]);

  useEffect(() => {
    if (width < 1024) {
      setEnableSticky(false);
      if (mainContainer.current) {
        setItineraryHeight(mainContainer.current.offsetHeight);
      }
      document.body.style.overflow = 'auto';
      if (headerState.isPanelOpen) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      setEnableSticky(true);
      setItineraryHeight('auto');
      document.body.style.overflow = 'auto';
    }
  }, [currentBookingData, width, enableSticky]);

  const airRedirectError = getSessionStorageItem(SESSION_STORAGE_AIR_REDIRECT_ERROR);

  setTimeout(() => {
    setSessionStorageItem(SESSION_STORAGE_AIR_REDIRECT_ERROR, null);
  }, 20000);

  useEffect(() => {
    const content = document.querySelector('main');
    if (propNotification.open && content) {
      content.scrollTo(0, 0);
      window.scrollTo(0, 0);
    }
  }, [propNotification]);

  useEffect(() => {
    const { hash } = window.location;

    if (hash === '#edit-guest-info' && editGuestRef.current) {
      const element = editGuestRef.current;
      const yOffset = -300;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, [editGuestRef.current]);

  useEffect(() => {
    if (airRedirectError === 'BOOKING_STATUS_COURTESY_HOLD') {
      setPropNotification({
        title: renderContent('AmendDashboardCourtesyHoldWarningTitle', 'Courtesy Hold'),
        description: renderContent(
          'AmendDashboardCourtesyHoldWarningDescription',
          'To purchase flights, please make sure your cruise minimum deposit has been paid',
        ),
        type: 'warning',
        open: true,
      });
    } else if (airRedirectError === 'BOOKING_WITH_FLIGHT') {
      setPropNotification({
        title: renderContent('amendDashboardFlightsBookedWarningTitle', 'Flights already booked'),
        description: renderContent(
          'amendDashboardFlightsBookedWarningDescription',
          'There are flights already booked for this reservation. See details below',
        ),
        type: 'warning',
        open: true,
      });
    }
  }, [airRedirectError]);

  const getDictionariesPartialPayment = () => {
    return {
      amendErrorOnlyPaymentCardLabel: renderContent(
        'amendErrorOnlyPaymentCardLabel',
        'Only the payment with card',
      ),
      amendErrorOnlyPaymentCardsLabel: renderContent(
        'amendErrorOnlyPaymentCardsLabel',
        'Only the payment with cards',
      ),
      amendErrorHasBeenAppliedLabel: renderContent(
        'amendErrorHasBeenAppliedLabel',
        'has been applied.',
      ),
      amendErrorHaveBeenLabel: renderContent('amendErrorHaveBeenLabel', 'have been applied.'),
      amendErrorYouHaveUntilDateLabel: renderContent(
        'amendErrorYouHaveUntilDateLabel',
        'You have until',
      ),
      amendErrorDateToPayYourRemaningBalanceLabel: renderContent(
        'amendErrorDateToPayYourRemaningBalanceLabel',
        'to pay your remaining balance.',
      ),
      amendErrorDueDateExceededLabel: renderContent(
        'amendErrorDueDateExceededLabel',
        'Remaining balance needs to be paid today',
      ),
      amendErrorPaymentWasSuccessfulLabel: renderContent(
        'amendErrorPaymentWasSuccessfulLabel',
        'Payment was successful.',
      ),
      amendErrorPaymentWereSuccessfulLabel: renderContent(
        'amendErrorPaymentWereSuccessfulLabel',
        'Payments were successful.',
      ),
    };
  };

  const showNotificationBannerPartialPayments = ({ cardsAccepted, messageTrigger = '' }) => {
    const {
      amendErrorOnlyPaymentCardLabel,
      amendErrorOnlyPaymentCardsLabel,
      amendErrorHasBeenAppliedLabel,
      amendErrorHaveBeenLabel,
      amendErrorYouHaveUntilDateLabel,
      amendErrorDateToPayYourRemaningBalanceLabel,
      amendErrorDueDateExceededLabel,
      amendErrorPaymentWasSuccessfulLabel,
      amendErrorPaymentWereSuccessfulLabel,
    } = getDictionariesPartialPayment();
    const priceData = getSessionStorageItem(SESSION_STORAGE_PRICE_BOOKING);
    const { balanceDueDate } = priceData;
    const dueDate = localizedDayjs(balanceDueDate).format('MMMM D, YYYY');

    const isOverDueDate = localizedDayjs(balanceDueDate).diff(localizedDayjs(), 'day') < 0;
    const dueDateErrorMessage = isOverDueDate
      ? amendErrorDueDateExceededLabel
      : `${amendErrorYouHaveUntilDateLabel} ${dueDate} ${amendErrorDateToPayYourRemaningBalanceLabel}`;

    const errorDescription = `
      ${
        cardsAccepted.length === 1
          ? amendErrorOnlyPaymentCardLabel
          : amendErrorOnlyPaymentCardsLabel
      }
      ${' '}
      ${cardsAccepted.join(', ')}
      ${' '}
      ${cardsAccepted.length === 1 ? amendErrorHasBeenAppliedLabel : amendErrorHaveBeenLabel}
      ${' '}
      ${dueDateErrorMessage} ${messageTrigger}`;

    const errorTitle =
      cardsAccepted.length === 1
        ? amendErrorPaymentWasSuccessfulLabel
        : amendErrorPaymentWereSuccessfulLabel;
    setPropNotification({
      description: errorDescription,
      title: errorTitle,
      open: true,
      type: 'success',
    });
  };

  const showNotificationCancelSchedule = () => {
    const title = renderContent(
      'paymentNotificationCancelScheduleTitle',
      'Schedule Payments has been successfully deactivated',
    );
    const priceData = getSessionStorageItem(SESSION_STORAGE_PRICE_BOOKING);
    const date = localizedDayjs(priceData.balanceDueDate).format('MMM D, YYYY');
    const description = renderContent(
      'paymentNotificationCancelScheduleDescription',
      `Your have until {date} to pay your remaining balance.`,
    );
    const descriptionWithDate = description.replace('{date}', date);
    setPropNotification({
      description: descriptionWithDate,
      title,
      open: true,
      type: 'success',
    });
  };

  const showNotificationUpdateSchedule = () => {
    const title = renderContent(
      'paymentNotificationUpdateScheduleTitle',
      'Your changes were successfully updated',
    );
    const description = renderContent(
      'paymentNotificationUpdateScheduleDescription',
      `Your scheduled payments have been adjusted accordingly.`,
    );
    setPropNotification({
      description,
      title,
      open: true,
      type: 'success',
    });
  };

  const showNotificationCustomSchedulePayment = () => {
    const title = renderContent(
      'paymentNotificationCustomSchedulePaymentTitle',
      'Your payment has been successfully applied.',
    );
    const description = renderContent(
      'paymentNotificationCustomSchedulePaymentDescription',
      `Due to the additional payment, please review your schedule payment installments`,
    );
    setPropNotification({
      description,
      title,
      open: true,
      type: 'success',
    });
  };

  const showNotificationCreateSchedule = () => {
    const title = renderContent(
      'paymentNotificationCreateScheduleTitle',
      'Thank you! Your payments are now scheduled.',
    );
    const description = renderContent(
      'paymentNotificationCreateScheduleDescription',
      `An email confirmation has been sent. Payment installments can be edited or cancelled up until final payment.`,
    );
    setPropNotification({
      description,
      title,
      open: true,
      type: 'success',
    });
  };

  const showNotificationBannerAffirmPayments = (messageTrigger = '') => {
    setAffirmSuccessBanner({ open: true, message: messageTrigger });
  };

  const showNotificationBannerApplePayments = ({ cardNumber, messageTrigger = '' }) => {
    setAppleSuccessBanner({ open: true, message: messageTrigger, cardNumber });
  };

  const showNotificationBannerSuccessPayments = ({
    remainingBalance,
    balanceDueDate,
    messageTrigger = '',
  }) => {
    const title =
      remainingBalance > 0
        ? renderContent(
            'paymentNotificationSuccessTitlePartialPay',
            'Your payment has been applied.',
          )
        : renderContent(
            'paymentNotificationSuccessTitleFullPaid',
            'Your booking has been paid in full.',
          );
    const description =
      remainingBalance > 0
        ? `${renderContent(
            'paymentNotificationDescriptionPaidUntil',
            'You paid until',
          )} ${localizedDayjs(balanceDueDate).format('MMMM D, YYYY')} ${renderContent(
            'paymentNotificationSuccessDescriptionToPay',
            'to pay your remaining balance.',
          )} ${messageTrigger}`
        : '';
    setPropNotification({
      title,
      description,
      open: true,
      type: 'success',
    });
  };

  useEffect(() => {
    if (handleLocation?.state?.paymentResponse) {
      const { remainingBalance } = handleLocation.state.paymentResponse.makePayment;
      const { paymentOption } = handleLocation.state;
      const { balanceDueDate } = handleLocation.state.priceData;
      const gcPaymentAmount = getOnlyGCPaymentAmount(handleLocation.state.payments);
      const creditCardType = getCreditCardType(handleLocation.state.payments);
      const paymentTraker = {
        paymentAmount: gcPaymentAmount,
        creditCardType: creditCardType?.[0],
      };

      if (paymentOption === 'affirm') {
        const affirmAmount = handleLocation.state.payments?.variables.makePaymentInput[0].amount;
        trackAffirmSuccess(affirmAmount);
      }

      if (gcPaymentAmount) {
        trackSuccesGiftCardPayment(paymentTraker);
      }

      setPaymentResponseInfo(handleLocation.state.paymentResponse);
      if (paymentOption !== 'affirm') {
        showNotificationBannerSuccessPayments({
          remainingBalance,
          balanceDueDate,
        });
      } else if (paymentOption === 'affirm') {
        showNotificationBannerAffirmPayments();
      }
    } else if (handleLocation?.state?.partialPayment) {
      const { cardsAccepted } = handleLocation.state.partialPayment;
      const paymentTraker = {
        paymentAmount: handleLocation.state.partialPayment.makePayment.paymentAmount,
        creditCardType: null,
      };

      trackSuccesGiftCardPayment(paymentTraker);
      setPaymentResponseInfo({
        makePayment: handleLocation.state.partialPayment.makePayment,
      });
      showNotificationBannerPartialPayments({ cardsAccepted });
    }
  }, [handleLocation, localizedDayjs]);

  useEffect(() => {
    if (currentBookingData && !currentBookingLoading) {
      if (handleLocation?.state?.upc?.status === 'SUCCESS') {
        const messageTrigger = handleLocation.state.upc.triggerUpdateStatusError
          ? renderContent(
              'formBookingAmendTriggerUpdateMessage',
              'The  status update of your booking will be reflected in 24 hours',
            )
          : '';
        const isAffirmPayment = handleLocation.state.upc.cardsAccepted.filter(
          (card) => card.option === UPC_PAYMENT_OPTIONS.AFFIRM,
        );
        const isApplePay = handleLocation.state.upc.cardsAccepted.filter(
          (card) => card.option === UPC_PAYMENT_OPTIONS.APPLE_PAY,
        );
        if (isAffirmPayment.length) {
          trackAffirmSuccess(isAffirmPayment[0].amount);
          showNotificationBannerAffirmPayments(messageTrigger);
          return;
        }
        if (isApplePay.length) {
          const { cardNumber } = isApplePay[0];
          showNotificationBannerApplePayments({ cardNumber, messageTrigger });
          return;
        }

        const priceData = getSessionStorageItem(SESSION_STORAGE_PRICE_BOOKING);
        const { balanceDueDate, balanceDue } = priceData;
        showNotificationBannerSuccessPayments({
          balanceDueDate,
          remainingBalance: balanceDue,
          messageTrigger,
        });
      }
      if (handleLocation?.state?.upc?.status === 'PARTIAL') {
        const messageTrigger = handleLocation.state.upc.triggerUpdateStatusError
          ? renderContent(
              'formBookingAmendTriggerUpdateMessage',
              'The  status update of your booking will be reflected in 24 hours',
            )
          : '';
        const cardsNumbersAccepted = handleLocation.state.upc.cardsAccepted.map(
          (card) => card.cardNumber,
        );
        showNotificationBannerPartialPayments({
          cardsAccepted: cardsNumbersAccepted,
          messageTrigger,
        });
      }
      if (handleLocation?.state?.upc?.status === 'CANCEL_SCHEDULE_PAYMENT') {
        showNotificationCancelSchedule();
      }
      if (handleLocation?.state?.upc?.status === 'UPDATE_SCHEDULE_PAYMENT') {
        showNotificationUpdateSchedule();
      }
      if (handleLocation?.state?.upc?.status === 'CREATE_SCHEDULE_PAYMENT') {
        showNotificationCreateSchedule();
      }
      if (handleLocation?.state?.upc?.status === 'CUSTOM_SCHEDULED') {
        showNotificationCustomSchedulePayment();
      }
    }
    const content = document.querySelector('main');
    if (content) {
      content.scrollTo(0, 0);
      window.scrollTo(0, 0);
    }
  }, [handleLocation, localizedDayjs, currentBookingData, currentBookingLoading]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (headerState.isPanelOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [headerState]);

  useEffect(() => {
    const guestAccountCreationTime =
      getSessionStorageItem(SESSION_STORAGE_GUEST_ACCOUNT_CREATION) || null;
    if (guestAccountCreationTime) {
      const fomatedIsoDate = guestAccountCreationTime?.replace(
        /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/,
        '$1-$2-$3T$4:$5:$6Z',
      );

      const gaCreated = new Date(fomatedIsoDate); // get client GMT time
      const currentTime = localizedDayjs();
      const timeFromCreation = currentTime.diff(gaCreated);
      const isNewGuestAccount = timeFromCreation <= 20000;

      if (isNewGuestAccount) {
        setPropNotification({
          description: getDictionaryValue(
            Dictionary.bookingAmendNotificationNewGuestAccountMessage.key,
          ),
          open: true,
          title: getDictionaryValue(Dictionary.bookingAmendNotificationNewGuestAccountTitle.key),
          type: 'success',
        });
      }
    }
    if (airCh) {
      setPropNotification({
        description: getDictionaryValue(Dictionary.bookingAmendChAirMessage.key),
        open: true,
        title: getDictionaryValue(Dictionary.amendHeroCourtesyHoldLabel.key),
        type: 'warning',
      });
      removeSessionStorageItem('air-ch');
    }
  }, []);

  useEffect(() => {
    if (
      allPropertiesDefined(trackingParams) &&
      isObjectNotEmpty(trackingParams) &&
      !trackPageViewSent
    ) {
      trackPageView(trackingParams);
      setTrackPageViewSent(true);
    }
  }, [trackingParams]);

  const checkBookingOnGuestAccount = () => {
    if (guestAccountData) {
      return guestAccountData?.some((item) => {
        return Number(item.bookingId) === Number(bookingId);
      });
    }
    return false;
  };

  const isBookingOnGuestAccount = checkBookingOnGuestAccount();
  const isGuestLogged = getCookies(COOKIE_KEYS.ACCESS_TOKEN);

  useEffect(() => {
    if (isBookingOnGuestAccount) {
      setSessionStorageItem(MAIN_PROFILE_BOOKING_ID, bookingId);
    }

    if (isBookingOnGuestAccount !== undefined && isGuestLogged && isBookingOnGuestAccount) {
      setSessionStorageItem(SESSION_STORAGE_EXTERNAL_BOOKING, false);
      setNobookingAssociatedNotification(false);
    } else if (isGuestLogged) {
      setSessionStorageItem(SESSION_STORAGE_EXTERNAL_BOOKING, true);
      setNobookingAssociatedNotification(true);
    }
  }, [bookingId, isGuestLogged]);

  let currency;
  if (currentBookingError && !invalidFlightProfile && !invalidSailing) {
    // eslint-disable-next-line consistent-return
    return <h2>Error retrieving booking</h2>;
  }
  if (currentBookingLoading || ldLoadingD || dispatchLoader) {
    // eslint-disable-next-line consistent-return
    return (
      <Loader
        display
        message={
          (currentBookingLoading || ldLoadingD) &&
          getDictionaryValue(Dictionary.loaderDashboardRedirect.key)
        }
      />
    );
  }

  const currentBookingDataMap = skipCurrentBookingQuery
    ? handleLocation.state.booking
    : currentBookingData?.currentBooking;

  if (currentBookingDataMap) {
    const {
      id,
      sailing,
      guests,
      stateroom,
      status,
      price,
      linkedBookings,
      flightProfile,
      country,
      type,
    } = currentBookingDataMap;

    const staterooms = [];
    const primaryBooking = { id, sailing, guests, stateroom, status, price };
    const isCourtesyHold = status === BOOKING_STATUS_OFFERED;
    currency = price?.currencyCode;
    staterooms.push(primaryBooking);

    const isTaBookingType = type === BOOKING_TYPES.TA;
    const isGrpBookingType = type === BOOKING_TYPES.GRP;
    const isVpBookingType = type === BOOKING_TYPES.VP;
    const isFlightSectionAllowed = !isTaBookingType && !isGrpBookingType;
    const isBrasilMarket = bookingCountry === BAZIL_MARKET;

    const isBookedStatus = status === BOOKING_STATUS_BOOKED;
    const isOfferedStatus = status === BOOKING_STATUS_OFFERED;
    const isTaxesAndFeesFlag = ldFlags?.[ENABLE_BUNDLED_TAXES_AND_FEES];
    const renderPaidInFullVersion = isBrasilMarket || isVpBookingType;

    const dictionaries = {
      paymentBookingAmendFlightTextRemaining: renderContent(
        'paymentBookingAmendFlightTextRemaining',
        'Your remaining balance includes',
      ),
      paymentBookingAmendFlightCruisesText: renderContent(
        'paymentBookingAmendFlightCruisesText',
        'cruise fare + flights',
      ),
      paymentBookingAmendEnsureText: renderContent(
        'paymentBookingAmendEnsureText',
        'To ensure that your reservation is not cancelled, please pay your remaining balance in full by',
      ),

      room: renderContent('formBookingAmendRoomLabel', 'Room'),
      guests: renderContent('stateroomBookingAmendViewAllLabel', 'Edit guest information'),
      viewGuest: renderContent('stateroomBookingAmendPreferencesLabel', ' View guest info'),
      startPlanning: renderContent('heroStartPlanningButton', 'Start Planning'),
      heroTitleCompleteGuestInfo: renderContent(
        'heroTitleCompleteGuestInfo',
        'Next Step: Complete Guest Information',
      ),
      amendHeroRoyalUpSubtitle: renderContent(
        'amendHeroRoyalUpSubtitle',
        "It's time to bid for an Upgrade!",
      ),
      amendHeroRoyalUpDescription: renderContent(
        'amendHeroRoyalUpDescription',
        'Explore available staterooms and bid for a chance to win an upgrade.',
      ),
      amendHeroRoyalUpButton: renderContent('amendHeroRoyalUpButton', 'View offers'),
      heroBookingAmendCourtesyHoldTitle: renderContent(
        'heroBookingAmendCourtesyHoldTitle',
        'Your booking is on hold',
      ),
      guarantee: renderContent('formBookingAmendGuaranteeLabel', 'Guarantee'),
      deck: renderContent('formBookingAmendDeckLabel', 'Deck'),
      edit: renderContent('formBookingAmendEditLabel', 'Edit'),
      freeOnboardSpendingCredit: renderContent(
        'freeOnboardSpendingCredit',
        'Free Onboard Spending Credit',
      ),
      prePaidGratuities: renderContent('paymentBookingAmendPrePaidLabel', 'Pre-Paid Gratuities'),
      vacationProtection: renderContent('paymentBookingAmendVPLabel', 'Vacation protection'),
      subtotal: renderContent('paymentBookingAmendSubTotalLabel', 'Subtotal'),
      taxesAndFees: renderContent('paymentBookingAmendTaxesAndFeesLabel', 'Taxes and fees'),
      roomTotal: renderContent('paymentBookingAmendRoomTotalLabel', 'Room total'),
      viewText: renderContent('paymentBookingAmendViewLabel', 'View'),
      cancellationPolicyText: renderContent(
        'paymentBookingAmendCancelPolicyLabel',
        'Cancellation Policy',
      ),
      paymentHeaderTitle: renderContent('paymentBookingAmendHeaderTitle', 'Payment Summary'),
      paymentStateTitle:
        price.balanceDue <= 0 || renderPaidInFullVersion
          ? renderContent('paymentBookingAmendPaidInFull', 'Paid in Full')
          : renderContent('paymentBookingAmendRemainingBalance', 'Remaining balance'),
      details: renderContent('paymentBookingAmendViewDetailLabel', 'View pricing details'),
      paymentBookingAmendSubmitButton:
        price.balanceDue > 0
          ? renderContent('paymentBookingAmendSubmitButton', 'Make a payment')
          : renderContent(
              'paymentBookingAmendSubmitButtonViewPaymentHistory',
              'View Payment History',
            ),
      dueText: renderContent('paymentBookingAmendDueLabel', 'Due'),
      paymentTitleText: renderContent('paymentBookingAmendSectionTitle', 'Payment details'),
      back: renderContent('headerBookingAmendBackLabel', 'Back'),
      leaving: renderContent('itineraryBookingAmendLeaving', 'Leaving'),
      from: renderContent('itineraryBookingAmendFrom', 'from'),
      onboard: renderContent('itineraryBookingAmendOnboard', 'Onboard'),
      flightCosts: renderContent('paymentBookingAmendFlightCostsLabel', 'Flight Costs'),
      preTour: renderContent('paymentBookingAmendPreTourLabel', 'Pre Tour Charges'),
      bookingAmendPaymentProcessTime: renderContent(
        'bookingAmendPaymentProcessTime',
        'To ensure that your reservation is not cancelled, please pay your deposit by ',
      ),
      courtesyHoldView: renderContent(
        'courtesyHoldView',
        'To ensure that your reservation is not cancelled, please pay your deposit by',
      ),
      paymentBookingAmendCongratsText: renderContent(
        'paymentBookingAmendCongratsText',
        'Congratulations',
      ),
      paymentBookingAmendRemainingText: renderContent(
        'paymentBookingAmendRemainingText',
        'Payment received and approved. Transaction processing time: 1 business day. Thanks!',
      ),
      dueDatePreposition: renderContent('dueDatePreposition', ' at '),
      easternStandardTime: renderContent('easternStandardTime', 'EST'),
      chMinimumDeposit: renderContent('chMinimumDeposit', 'Minimum deposit'),
      totalBalanceCourtesyHold: renderContent('totalBalanceCourtesyHold', 'Total Balance'),
      managePaymentCTA: renderContent('managePaymentCTA', 'Manage payment'),
      amendGuestAccountNoBookingAssociated: renderContent(
        'amendGuestAccountNoBookingAssociated',
        'No booking associated with that account',
      ),
      amendPaymendDetailsBalanceDueDateLabel: renderContent(
        'amendPaymendDetailsBalanceDueDateLabel',
        'Balance due date',
      ),
      amendPaymendDetailsBalanceDepositDateLabel: renderContent(
        'amendPaymendDetailsBalanceDepositDateLabel',
        'Deposit due date',
      ),
      amendPaymendDetailsMessageAdviceComplete: renderContent(
        'amendPaymendDetailsMessageAdviceComplete',
        '*To avoid cancellation of this reservation, complete payment by',
      ),
      amendPaymendDetailsMessageAdvicePay: renderContent(
        'amendPaymendDetailsMessageAdvicePay',
        '*To avoid cancellation of this reservation, pay minimum deposit by',
      ),
      amendPaymentHistoryTitle: renderContent('amendPaymentHistoryTitle', 'Payment history'),
      paymentBookingAmendPaymentDate: renderContent('paymentBookingAmendPaymentDate', 'Date'),
      paymentBookingAmendAmount: renderContent('paymentBookingAmendAmount', 'Amount'),
      paymentBookingAmendPaymentMethod: renderContent(
        'paymentBookingAmendPaymentMethod',
        'Payment method',
      ),
      paymentBookingAmendType: renderContent('paymentBookingAmendType', 'Type'),
      amendPaidSuccessfully: renderContent('amendPaidSuccessfully', 'Paid successfully'),
      amendPaymentStatus: renderContent('amendPaymentStatus', 'Payment status'),
      amendPaymentCompleted: renderContent('amendPaymentCompleted', 'Completed'),
      amendPaymentTotalBalancePaid: renderContent(
        'amendPaymentTotalBalancePaid',
        'Total balance paid',
      ),
      amendPaymentTableHeaderStatus: renderContent('amendPaymentTableHeaderStatus', 'Status'),
      amendPaymentTableRowPaid: renderContent('amendPaymentTableRowPaid', 'Paid'),
      amendPaymentScheduleDateTitle: renderContent(
        'amendPaymentScheduleDateTitle',
        'Schedule date',
      ),
      amendPaymentSchedulePaymentAmount: renderContent(
        'amendPaymentSchedulePaymentAmount',
        'Payment amount',
      ),
      amendPaymentSPCtaButton: renderContent('amendPaymentSPCtaButton', 'Manage payment'),
      paymentBookingAmendRemainingBalance: renderContent(
        'paymentBookingAmendRemainingBalance',
        'Remaining balance',
      ),
    };

    const itinerary = sailing?.itinerary;
    const itineraryDays = itinerary?.days;

    const arrivalDate =
      itineraryDays &&
      localizedDayjs(
        `${sailing?.sailDate}T${itineraryDays[itineraryDays.length - 1].ports[0].arrivalTime}`,
      ).add(itinerary?.totalNights, 'days');
    const itinearySummary = {
      name: itinerary?.name,
      description: itinerary?.description,
      sailDate: sailing?.sailDate,
      arrivalDateTime: arrivalDate,
      departureDateTime:
        itineraryDays && `${sailing?.sailDate}T${itineraryDays[0].ports[0].departureTime}`,
      departurePort: itinerary?.departurePort,
      ship: itinerary?.ship,
      totalNights: itinerary?.totalNights,
      days: [],
      paymentErrorInfo,
      showNotification,
    };
    const priceVar = {
      bookingId: id,
      balanceDue: price.balanceDue,
      balanceDueDate: price.balanceDueDate,
      currencyCode: price.currencyCode,
      inFinal: price.inFinal,
      total: price.total,
      totalBalanceDue: price.totalBalanceDue,
      paymentsApplied: price.paymentsApplied,
      depositAmountOwed: price.depositAmountOwed,
      depositAmount: price.depositAmount,
      depositPaid: price.depositPaid,
    };

    setCurrentSailingVar(itinearySummary);
    setCurrentPriceVar(priceVar);
    const makeAPaymentPageSection = {
      title: renderContent('paymentBookingAmendSubmitButton', 'Make a payment'),
      description: renderContent(
        'paymentBookingAmendDescription',
        "Please choose if you'd like to pay off your remaining balance, or if you'd like to pay a custom amount instead. Then enter and verify your credit card information before submitting your payment. You can only make payments online if you have booked directly with Royal Caribbean.",
      ),
    };

    const paymentOverlayProps = {
      description: itinerary?.name,
      arrivalDateTime:
        itinerary &&
        localizedDayjs(sailing?.sailDate).add(itinerary?.totalNights, 'days').format('MMM D, YYYY'),
      departurePort: itinerary?.departurePort,
      departureDateTime: localizedDayjs(sailing?.sailDate).format('MMM D, YYYY'),
      ship: itinerary?.ship,
      dictionaries,
      pageSection: makeAPaymentPageSection,
      price,
      setMakePaymentInfo,
      setPaymentErrorInfo,
      setPaymentResponseInfo,
      paymentResponse: paymentResponseInfo,
      paymentErrorInfo,
      renderContent,
      showNotification,
      payment3dsToggle: ldFlags?.[ENABLE_3DS_PAYMENT_GATEWAY],
    };

    const roomInfo = {
      ...staterooms[0],
      dinnerTab,
      id,
      roomIndex: 0,
    };

    const handleStateroomEditClick = (e, selectedGuest) => {
      setGuestModal(true);
      setGuestNumber(selectedGuest);
      if (succesUpdate) {
        refetch();
      }
      setModalState({ isModalOpen: true });

      trackPreferencesView(e);
      trackGuestInfoInteraction('opened');
      if (handleLocation?.state) handleLocation.state = null;
    };

    const closeModal = () => {
      setModalState({ isModalOpen: false });
      if (succesUpdate) {
        refetch();
      }
      setDinnerTab({ dinnerTab: false });
      setPaymentModal(false);
      setPaymentErrorInfo(null);
      setShowNotification(false);
    };

    const setNotificationDashboard = () => {
      if (paymentResponseInfo) {
        const { remainingBalance } = paymentResponseInfo.makePayment;
        setPropNotification({
          description:
            remainingBalance > 0
              ? `${renderContent(
                  'paymentNotificationDescriptionPaidUntil',
                  'You paid until',
                )} ${localizedDayjs(price.balanceDueDate).format('MMMM D, YYYY')} ${renderContent(
                  'paymentNotificationSuccessDescriptionToPay',
                  'to pay your remaining balance.',
                )}`
              : '',
          title:
            remainingBalance > 0
              ? renderContent(
                  'paymentNotificationSuccessTitlePartialPay',
                  'Your payment has been applied.',
                )
              : renderContent(
                  'paymentNotificationSuccessTitleFullPaid',
                  'Your booking has been paid in full.',
                ),
          open: true,
          type: 'success',
        });
      }
    };

    const createImagePath = (imagePath, size) => `${IMAGES.BASE_URL}${imagePath}?$${size}$`;
    const portImagesReducer = (resp) => {
      let images = [];
      images = IMAGES.IMAGE_SIZES.map((size) => ({
        url:
          resp && Array.isArray(resp.images) && resp.images.length > 0 && resp.images[0].path
            ? createImagePath(resp.images[0].path, size.size)
            : IMAGES.DEFAULT_PORT_IMAGE,
        size: size.size,
        key: size.key,
      }));
      return images;
    };
    // eslint-disable-next-line consistent-return
    const modalContent = () => {
      if (paymentModal) {
        return (
          <PaymentOverlay
            {...paymentOverlayProps}
            currentBooking={{ id, price }}
            royalPayway={royalPayway}
            isMobile={isMobile}
            setNotificationDashboard={setNotificationDashboard}
            closeModal={closeModal}
            refetch={refetch}
          />
        );
      }
      if (guestModal) {
        return (
          <Preferences
            {...{ ...roomInfo, country, setSuccesUpdate, ldFlags }}
            primaryBooking={primaryBooking}
            guestTab={guestNumber}
          />
        );
      }
    };

    // Logic for add a flight section
    const isAFlightbooked = flightProfile?.guests?.some(
      ({ flightGuest }) => flightGuest?.guestFlights,
    );
    const showBookAdditionalFlight = isAGuestWithoutFlight(flightProfile);
    let showFlightComponent = false;

    if (
      isBookedStatus &&
      isGuestInfoComplete(currentBookingDataMap) &&
      !isAFlightbooked &&
      !invalidFlightProfile &&
      isFlightSectionAllowed
    ) {
      showFlightComponent = true;
    }
    const shouldRenderAffirm = showAffirm(currency, price.balanceDue, ldFlags);

    const itinerarySailDate = {
      sailDate: sailing?.sailDate,
      ...sailing.itinerary,
    };

    const pretourDays = sailing?.itinerary?.preTour?.duration || 0;
    const sailDateUpdated = localizedDayjs(sailing?.sailDate)
      .add(-pretourDays, 'days')
      .format('YYYY-MM-DD');

    /* eslint-disable */
    const urlPathStartPlanning = () => {
      if (market === 'usa') {
        let shipCode = itinerary?.ship?.code;
        if (!shipCode) {
          const booking = getSessionStorageItem(PROFILE_BOOKING_DATA)?.find(
            ({ bookingId }) => bookingId === id
          );
          shipCode = booking?.shipCode;
        }
        return globalizationPath(
          market,
          lang,
          `${START_PLANNING_USA_MARKET_PATH}?bookingId=${id}&shipCode=${shipCode}&sailDate=${sailing.sailDate.replace(
            /-/g,
            ''
          )}`
        );
      }
      return globalizationPath(market, lang, START_PLANNING_PATH);
    };

    const { bookingType, showEditGuestInformationCta, showViewGuestInformationCta } =
      ldFlags && getGuestInfoFlags(currentBookingDataMap, ldFlags);

    const statusForRenderViewGuestInfoCta = status || 'BOOKED';

    const isAccountBookingOwner = isGuestLogged && isBookingOnGuestAccount;

    const disabledField = disableEditGuestInformation(
      bookingType,
      showEditGuestInformationCta,
      showViewGuestInformationCta,
      isAFlightbooked,
      statusForRenderViewGuestInfoCta
    );
    const renderViewGuestInfoCta = disabledField || !isAccountBookingOwner || !isGuestInfoComplete(currentBookingDataMap);
    
    const clearStorage = () => {
      void setSessionStorageItem(AMEND_ORIGIN, 'true');
      void setSessionStorageItem(SESSION_STORAGE_CHANGE_FLIGHTS, false);
      void setSessionStorageItem(SESSION_STORAGE_BOOKING_PROFILE, null);
      void setSessionStorageItem(SESSION_STORAGE_FLIGHT_TYPE_CODE, null);
    };

    const handleBookAdditionalClick = () => {
      trackInteraction('amend:air:bookAdditional:clicked');
      clearStorage();
      setDispatchLoader(true);
      setTimeout(() => {
        const flightsPath = globalizationPath(market, lang, FLIGHTS_ROUTE);
        window.location.assign(flightsPath);
      }, 1500);
    };

    const handleRedirectToMangeFlight = () => {
      trackInteraction('amend:air:manageFlight:clicked');
      setSessionStorageItem(AMEND_ORIGIN, 'true');
      setDispatchLoader(true);
      setTimeout(() => {
        const flightsPath = globalizationPath(market, lang, FLIGHTS_MANAGE);
        window.location.assign(flightsPath);
      }, 1500);
    };

    const isAvaiblableJiraWidget = ldFlags ? ldFlags['enable-jira-widget'] : null;
    return (
      <div
        data-testid="main-container"
        ref={mainContainer}
        className={`${classes.root} ${headerState.isPanelOpen ? 'panel-open' : ''}`}
      >
        <Header
          className="header"
          headerFunc={setHeaderState}
          headerState={headerState}
          isLoggedIn={Boolean(guestAccountData)}
          fixPosition={fixPosition}
        />
        {guestAccountData && (
          <GuestAccountHeader
            guestAccountData={guestAccountData}
            setFixPosition={setFixPosition}
            labelNoBookingAssociated={dictionaries.amendGuestAccountNoBookingAssociated}
          />
        )}
        <main className={`${guestAccountData ? 'guest-account-active' : ''}`}>
          <div style={!itinerary ? { marginTop: '5px', marginBottom: '20px' } : {}}>
            {propNotification.open && (
              <div className={`${classes.notificationContainer} ${styles.notification}`}>
                <NotificationBannerComponent
                  {...propNotification}
                  renderCloseBtn
                  condensed={!propNotification.description}
                  isBannerOpen={true}
                  onClose={() => setPropNotification({ open: false })}
                />
              </div>
            )}
            {noBookingAssociatedNotification && (
              <div
                className={`${classes.notificationContainer} ${styles.notification} ${classes.linkNotification}`}
              >
                <NotificationBannerComponent
                  title={getDictionaryValue(
                    Dictionary.amendDashboardNotificationNoBookingLinkedTitle.key
                  )}
                  description=""
                  type="warning"
                  linkLabel={getDictionaryValue(
                    Dictionary.amendDashboardNotificationNoBookingLinkedDescription.key
                  )}
                  linkDestination={FIND_RESERVATION_PATH}
                  renderCloseBtn
                  isBannerOpen={true}
                  onClose={() => setNobookingAssociatedNotification(false)}
                />
              </div>
            )}
            {affirmSuccessBanner.open && (
              <div className={`${classes.notificationContainer} ${styles.notification}`}>
                <NotificationBannerComponent
                  title={getDictionaryValue(Dictionary.paymentNotificationSuccessTitleAffirm.key)}
                  description=""
                  type="success"
                  renderCloseBtn
                  useSlot
                  isBannerOpen={true}
                  onClose={() => setAffirmSuccessBanner({ open: false })}
                >
                  <div>
                    {getDictionaryValue(
                      Dictionary.paymentNotificationSuccessTitleFullPaidWithAffirm.key
                    )}{' '}
                    <img alt="affirm-logo" src={AFFIRM_LOGO} /> {affirmSuccessBanner?.message}
                  </div>
                </NotificationBannerComponent>
              </div>
            )}
            {appleSuccessBanner.open && (
              <div className={`${classes.notificationContainer} ${styles.notification}`}>
                <NotificationBannerComponent
                  title={renderContent('paymentNotificationSuccessTitleApple', 'Payment success')}
                  description=""
                  type="success"
                  renderCloseBtn
                  useSlot
                  isBannerOpen={true}
                  onClose={() => setAppleSuccessBanner({ open: false })}
                >
                  <div>
                    {renderContent(
                      'paymentNotificationSuccessDescriptionApple1',
                      'Your payment was successfully made with the card ending in'
                    )}{' '}
                    {appleSuccessBanner.card}{' '}
                    {renderContent('paymentNotificationSuccessDescriptionApple2', 'using')}{' '}
                    <img alt="apple-logo" className="apple-logo" src={APPLE_PAY_LOGO} />
                    {appleSuccessBanner?.message}
                  </div>
                </NotificationBannerComponent>
              </div>
            )}
          </div>
          <div style={{ display: 'flex' }}>
            {itinerary && (
              <aside className={`${guestAccountData ? 'guestAccountOn' : ' '} itinerary`}>
                {isDesktop ? (
                  <Itinerary
                    style={{ height: itineraryHeight }}
                    itinerary={itinerarySailDate}
                    bookingId={bookingId}
                  />
                ) : (
                  <Sticky
                    shouldFreeze={(enableStickyComponent) => enableStickyComponent}
                    bottomBoundary=".itinerary"
                  >
                    <Itinerary
                      style={{ height: itineraryHeight }}
                      itinerary={itinerarySailDate}
                      bookingId={bookingId}
                    />
                  </Sticky>
                )}
              </aside>
            )}
            <section
              className={`${guestAccountData ? 'guest-account-active' : ''} section-container`}
            >
              {(isBookedStatus || isOfferedStatus) && (
                <Box>
                  <Hero
                    images={portImagesReducer(itinerary?.media)}
                    isCourtesyHold={isCourtesyHold}
                    price={price}
                    isTaBookingType={isTaBookingType}
                    isGrpBookingType={isGrpBookingType}
                    renderPayment={renderPayment}
                    urlPathStartPlanning={urlPathStartPlanning()}
                    isBrasilMarket={isBrasilMarket}
                    itinerary={itinerary}
                    bookingStatus={status}
                    sailDateUpdated={sailDateUpdated}
                    schedulePaymentData={schedulePaymentData}
                  />

                  {!currentBookingLoading && !isTaBookingType && !isGrpBookingType && itinerary && (
                    <PageSection
                      className={`${classes.paymentDetails} ${
                        isAFlightbooked ? classes.paymentFlightDetails : ''
                      }`}
                      componentType="makePayment"
                      title={renderContent('paymentBookingAmendSectionTitle', 'Payment details')}
                    >
                      <PaymentDetails
                        activePopUp
                        bodyTitle={dictionaries.paymentStateTitle}
                        cancellationPolicy={dictionaries.cancellationPolicy}
                        componentTitle={dictionaries.paymentHeaderTitle}
                        currency={price.currencyCode}
                        dictionaries={dictionaries}
                        guests={guests}
                        isoCode={isoCode}
                        linkedBookings={linkedBookings}
                        language={lang}
                        price={price}
                        paymentInfo={dictionaries.paymentInfo}
                        staterooms={staterooms}
                        newLayout={newLayoutFlag}
                        renderPayment={renderPayment}
                        showAffirm={shouldRenderAffirm}
                        showTaxesAndFees={isTaxesAndFeesFlag}
                        isCourtesyHold={isCourtesyHold}
                        chMinimumDeposit={dictionaries.chMinimumDeposit}
                        dueDatePreposition={dictionaries.dueDatePreposition}
                        easternStandardTime={dictionaries.easternStandardTime}
                        chTime={MOCKED_COURTESY_HOLD_TIME}
                        totalBalanceCourtesyHold={dictionaries.totalBalanceCourtesyHold}
                        managePaymentCTA={dictionaries.managePaymentCTA}
                        isBrasilMarket={isBrasilMarket}
                        paidInFullVersion={renderPaidInFullVersion}
                        paymentHistoryData={paymentHistoryData}
                        schedulePaymentData={schedulePaymentData}
                      />
                    </PageSection>
                  )}
                  {upgradeEligible && (
                    <PageSection>
                      <RoyalUpContainer
                        image={staterooms[0]?.stateroom.image}
                        urlPathViewUpgrades={royalUpgrades?.offerUrl}
                        dictionaries={dictionaries}
                      />
                    </PageSection>
                  )}
                  {shouldRenderAvios && !isCasinoBooking &&  (
                    <PageSectionAvios>
                      <AviosContainer lang={lang} />
                    </PageSectionAvios>
                  )}
                  <Box className="stateRoom">
                    <PageSection
                      title={renderContent(
                        'dashboardStateroomSectionTitle',
                        'Stateroom and Guest Details'
                      )}
                      className={classes.customTitle}
                    >
                      {staterooms.map(
                        ({
                          stateroom: { accessible, deck, number, position, type, subType, image },
                          guests,
                          id,
                        }) => {
                          const gty = number === 'GTY';
                          return (
                            <Box
                              key={id}
                              ref={editGuestRef}
                              id="editGuestRef"
                              data-testid="stateroomcard"
                              className="stateRoom__card"
                            >
                              <StateroomCard
                                room={{
                                  accessible,
                                  deck: !gty && deck.code,
                                  guarantee: gty,
                                  guests,
                                  location: renderContent(`formBookingAmend${position}`, position),
                                  number,
                                  reservationNumber: id,
                                  type,
                                  subType,
                                  image,
                                }}
                                stateroomEditClick={handleStateroomEditClick}
                                renderViewGuestInfoCta={renderViewGuestInfoCta}
                              />
                            </Box>
                          );
                        }
                      )}
                    </PageSection>
                  </Box>
                  {itinerary && showFlightComponent && !isCourtesyHold && (
                    <AddFlights currency={currency} />
                  )}
                  {itinerary && isAFlightbooked && isFlightSectionAllowed && (
                    <FlightsInfoContainer flightProfile={flightProfile} />
                  )}
                  {itinerary && isAFlightbooked && isFlightSectionAllowed && (
                    <div className={classes.flightsButtonsWrapper}>
                      {showBookAdditionalFlight && (
                        <Button
                          data-testid="book-additional-flight-button"
                          className={classes.additionalFlightButton}
                          onClick={handleBookAdditionalClick}
                        >
                          {getDictionaryValue(Dictionary.bookAdditionalFlightButtonText.key)}
                        </Button>
                      )}
                      <Button
                        data-testid="manage-flight-button"
                        variant="contained"
                        color="primary"
                        className={classes.manageFlightButton}
                        onClick={handleRedirectToMangeFlight}
                      >
                        {getDictionaryValue(Dictionary.manageFlightButtonText.key)}
                      </Button>
                    </div>
                  )}
                </Box>
              )}
            </section>
          </div>
        </main>
        {isAvaiblableJiraWidget && <JiraIssueCollector />}
        <Footer />
        <aside>
          <Dialog
            data-testid="dialog-box"
            fullScreen
            onClose={closeModal}
            TransitionComponent={Grow}
            open={modalState.isModalOpen}
            scroll="paper"
            className={classes.root}
          >
            {paymentModal && (
              <royal-payway-three-ds
                env={REACT_APP_AIR_3DS_ENV}
                payment-channel="RW"
                ref={royalPayway}
                data-testid="royal-payway"
              />
            )}
            <DialogTitle
              classes={{ root: classes.root }}
              disableTypography
              id="scroll-dialog-title"
            >
              <Box className="closeButtonWrapper">
                <Link component="button" className="closeButton" onClick={closeModal}>
                  <KeyboardArrowLeft className="backArrow" />
                  <Typography component="span" className="backButton">
                    {dictionaries.back}
                  </Typography>
                </Link>
              </Box>
              <Box className="closeButtonWrapper closeButtonDesktop">
                <Link
                  data-testid="close-payment-modal"
                  component="button"
                  className="closeButton"
                  onClick={closeModal}
                >
                  <Clear className="closeModal" />
                </Link>
              </Box>
            </DialogTitle>
            <DialogContent
              dividers={false}
              className={clsx(classes.MuiDialogContentRoot, 'contentDialog')}
            >
              {modalContent()}
            </DialogContent>
          </Dialog>
        </aside>
      </div>
    );
  }
};

export default Dashboard;
